/* eslint-disable max-len */
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { CasinoType, ILangs } from '../../types/configuration';
import {
  IPopokgamingServerResponse,
  IPopokgamingServerGame,
  IIPopokgamingGetUrl,
} from '../../types/interfaces/Slots/Popokgaming';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getCategories } from '../../utils/liveCasinoSort';
import { shortLanguages } from 'services/locale';
import { IGetGameUrl } from '../../types/slot';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IPopokgamingServerResponse>): ISlotViewItem[] =>
    data.liveCasino
      .concat(data.miniGames.filter((game: IPopokgamingServerGame) => game.id === 609))
      .map((game: IPopokgamingServerGame) => ({
        id: game.id.toString(),
        gameId: game.id.toString(),
        provider: 'popokgaming',
        routeProvider: 'popokgaming',
        type: CasinoType.liveCasino,
        gameName: game.gameName,
        description: game.gameName,
        tab: getCategories(game.gameName, game.id.toString(), 'popokgaming'),
        imageUrl: game.thumbnail,
      }));

  convertGameUrl = ({ data, gameId, lang }: IGetGameUrl<IIPopokgamingGetUrl, unknown>) => {
    const needLang: ILangs = shortLanguages;
    // eslint-disable-next-line max-len
    return `https://se1.pokgaming.com/?partnerId=${data.provider_partner_id}&gameId=${gameId}&gameMode=real&lang=${needLang[lang]}&platform=${data.platform}&externalToken=${data.token}`;
  };
}
export default Converter;
